import { Component, ChangeDetectionStrategy } from '@angular/core';
var NglIconWaffle = (function () {
    function NglIconWaffle() {
    }
    NglIconWaffle.decorators = [
        { type: Component, args: [{
                    selector: 'ngl-icon-waffle,[ngl-icon-waffle]',
                    template: "\n    <div class=\"slds-icon-waffle\"><div class=\"slds-r1\"></div><div class=\"slds-r2\"></div><div class=\"slds-r3\"></div><div class=\"slds-r4\"></div><div class=\"slds-r5\"></div><div class=\"slds-r6\"></div><div class=\"slds-r7\"></div><div class=\"slds-r8\"></div><div class=\"slds-r9\"></div></div>\n  ",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    host: {
                        '[class.slds-icon-waffle_container]': 'true',
                    },
                },] },
    ];
    /** @nocollapse */
    NglIconWaffle.ctorParameters = function () { return []; };
    return NglIconWaffle;
}());
export { NglIconWaffle };
//# sourceMappingURL=waffle.js.map